<template>
  <div id="ClockResultDialog_main">
    <el-dialog
      title="打卡成功"
      :visible.sync="dialogVisible"
      custom-class="clockResultDialog"
      :close-on-click-modal="false"
      width="70%"
      @close="closeDialog"
    >
      <el-table
        :data="tableData"
        style="width: 100%"
        class="clockResultTable"
      >
        <el-table-column
          prop="managerName"
          label="姓名"
        />
        <el-table-column label="打卡時間">
          <template slot-scope="scope">
            <span>{{ scope.row.clockTime.substring(0,16) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="備註">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.note"
              type="textarea"
              :rows="4"
              placeholder="請輸入備註"
              maxlength="50"
              show-word-limit
            />
          </template>
        </el-table-column>
      </el-table>
      <div class="tip">
        ※若不需新增備註，請直接點選[確認]
      </div>
      <el-button
        type="primary"
        round
        @click="submitRemark()"
      >
        確認
      </el-button>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data () {
    return {
      dialogVisible: false,
      tableData: []
    }
  },
  mounted () {
  },
  methods: {
    openDialog (type, data) {
      this.dialogVisible = true
      this.type = type
      this.tableData.push(data)
    },
    closeDialog () {
      console.log('關閉彈窗')
      this.dialogVisible = false
      this.$toMainPage()
    },
    // 送出備註
    submitRemark () {
      if (this.tableData[0].note.length !== 0) {
        const queryPath = {
          ClockId: this.tableData[0].clockId
        }
        const requestData = {
          Note: this.tableData[0].note
        }
        if (this.type === 'ClockIn') {
          // 送出上班打卡備註
          apiAttendanceManagement.PutClockInRemark(
            queryPath,
            requestData
          ).then(res => {
          }).catch(err => {
            console.log('錯誤訊息：', err.response)
          })
          this.dialogVisible = false
          this.$toMainPage()
        } else {
          // 送出下班打卡備註
          apiAttendanceManagement.PutClockOutRemark(
            queryPath,
            requestData
          ).then(res => {
          }).catch(err => {
            console.log('錯誤訊息：', err.response)
          })
          this.dialogVisible = false
          this.$toMainPage()
        }
      } else {
        this.dialogVisible = false
        this.$toMainPage()
      }
    }
  }
}
</script>
<style lang="sass" scoped>
#ClockResultDialog_main
  ::v-deep .el-dialog.clockResultDialog
    +basicDialog
  ::v-deep .el-table
    +basicTable
    &.clockResultTable
      font-size: 16px
      tr:hover,tr.hover-row
        > td
          background-color: $white
          &:first-child
            border-left: 0
  .tip
    color: $blueColor
    text-align: left
    font-size: 16px
    line-height: 70px
</style>
